/**
 * Query keys for Deal Crawler API hooks.
 */

export const dealCrawlerQueryKeys = {
  all: ['cruise-deal-crawlers'] as const,
  lists: () => [...dealCrawlerQueryKeys.all, 'list'] as const,
  list: (params: { vendorId?: string }) => [...dealCrawlerQueryKeys.lists(), params] as const,
  byId: () => [...dealCrawlerQueryKeys.all, 'by-id'] as const,
  detail: (id: string) => [...dealCrawlerQueryKeys.byId(), id] as const,
};
